import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { heroMeta } from '../data/content';
import { BookStack } from './BookStack';
import { CtaButton } from './CtaButton';
export function Hero() {
  const reduce = useReducedMotion();
  return <header className="bg-cream" data-id="element-100" data-mp="9ipbpaa4vbzl">
      <div className="mx-auto max-w-[880px] px-5 pb-10 pt-12 text-center sm:px-8 sm:pt-16" style={{
      paddingTop: "0px"
    }} data-id="element-101" data-mp="4lyswf6y22ah">
        
        <h1 className="mt-7 text-balance font-display text-[2.6rem] font-normal leading-[1.03] tracking-[-0.02em] text-petrol sm:text-6xl lg:text-[4.2rem]" data-id="element-102" data-mp="128yxm77pblw0">
          Prepará meses de sesiones  <em className="text-terra" data-id="element-103" data-mp="sa9slf0wlvx6">en solo 5 minutos</em>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ink-soft sm:text-xl" data-id="element-104" data-mp="ncgiiawhchrm">
          Tené a mano todo lo que necesitás para dejar de improvisar y llegar a cada sesión con estructuras, preguntas, guiones orientativos e intervenciones listas para consultar y adaptar.
        </p>
      </div>

      <motion.div className="mx-auto max-w-[980px] px-4 sm:px-8" initial={reduce ? false : {
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-105" data-mp="3j896f9neq5ny">
        <BookStack data-id="element-106" data-mp="39cfjqxfz4vsg" />
      </motion.div>

      <div className="mx-auto max-w-[880px] px-5 pb-20 pt-10 text-center sm:px-8" style={{
      paddingTop: "2px",
      paddingBottom: "42px"
    }} data-id="element-107" data-mp="3e8wj6nsmiwku">
        
        <div className="mt-8 flex flex-col items-center gap-3" data-id="element-108" data-mp="30gq47517ivmz">
          <CtaButton data-id="element-109" data-mp="358ztqjyettoq">QUIERO ACCEDER A MAESTRO DE SESIONES</CtaButton>
          
        <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm font-medium text-petrol" data-id="element-110" data-mp="2qk3lomwcsgo4">
          {heroMeta.map((m, i) => <li key={m} className="flex items-center gap-4" data-id="element-111" data-mp="2vjzpal152635" data-mpi={i}>
              {i > 0 && <span className="h-1 w-1 rounded-full bg-terra" aria-hidden="true" data-id="element-112" data-mp="2hjf2zew0ls4w" />}
              {m}
            </li>)}
        </ul></div>
      </div>
    </header>;
}